import { createFileRoute } from '@tanstack/react-router'
import { number, object, optional, parse } from 'valibot'

import { fetchOwnPartner } from '@/features/partners/api'

// dcs/-models から import していたが、dcs/ サブツリー削除に伴いインライン化
// (PR #3433 レビュー指摘 https://github.com/simount/logi-go-tms/pull/3433#pullrequestreview-4308227313)
const dcsSearchSchema = object({
  page: optional(number()),
  status: optional(number())
})

export const Route = createFileRoute(
  '/_protected/$tenantKey/settings/own-partner/'
)({
  validateSearch: (search) => parse(dcsSearchSchema, search),
  loaderDeps: ({ search }) => search,
  loader: async ({
    abortController,
    params: { tenantKey },
    context: { auth }
  }) => {
    return {
      authUser: auth.user,
      ownPartner: await fetchOwnPartner(tenantKey, abortController.signal)
    }
  }
})
